import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
//img
import j290 from '../assets/j_290.jpg';
import legendimg from '../assets/legend.png';
import sleepimg from '../assets/sleep.png';
import layericon from '../assets/layericon.png';
import pointicon from '../assets/pointicon.png';
import oneload from '../assets/oneload.png';
import storeicon from '../assets/storeicon.png';
import resticon from '../assets/resticon.png';
import babyicon from '../assets/babyicon.png';
import foodicon from '../assets/foodicon.png';
import restroomicon from '../assets/restroom.png';
import pharmacyicon from '../assets/pharmacyicon.png';
//openlayers 
import "ol/ol.css"; // OpenLayers 기본 스타일
import { Switch, FormControlLabel } from "@mui/material";
import { Map, View } from "ol";
import { fromLonLat } from "ol/proj";
import { OSM, TileWMS, Cluster, Vector as VectorSource } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Style, Circle as CircleStyle, Fill, Stroke, Text, Icon,} from "ol/style";
import { Feature } from "ol";
import Point from "ol/geom/Point";
import Overlay from 'ol/Overlay';
import { gateway } from "../Data/gatewaydata";
import axios from 'axios';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { XYZ } from 'ol/source';
import KrpanoExample from "./Krpano";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";




const TrafficInformationPage = () => {
  //axios.defaults.adapter = require('axios/lib/adapters/xhr');
    const [isExpanded, setIsExpanded] = useState(false);
    const [symbol, setSymbol] = useState('❮');
    const [selectedInfo, setSelectedInfo] = useState({
      "휴게소명": "망향(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.8556501,
      "경도": 127.180929,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "open": "00:00",
      "close": "23:59",
      "도로점용면적": 34779,
      "주차면수": 329,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "명품한우국밥",
      "휴게소전화번호": "041-557-4000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },);
    const [routeName, setRouteName] = useState('경부선'); // 기본값 설정
    const [restAreas, setRestAreas] = useState([]); // 휴게소 목록 상태
    const [sleepAreas, setSleepAreas] = useState([]); // 졸음쉼터 목록 상태
    const [selectedRestArea, setSelectedRestArea] = useState("안성(부산)"); // 선택된 휴게소
    const [filteredData, setFilteredData] = useState([]);
    const [map, setMap] = useState(null);
    const [view, setView] = useState(null); // View 객체 저장
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [vworldVisible, setVworldVisible] = useState(false);
    const [sleepVisible, setSleepVisible] = useState(false);
    const mapRef = useRef(null);
    const highwayOptions = ['경부선', '중앙선', '서해안선']; // 선택 가능한 고속도로
    const [direction, setDirection] = useState("하행"); // 기본값은 '상행'
    const [isUp, setIsUp] = useState(false); // "상행" 활성화 여부
    const [isDown, setIsDown] = useState(true); // "하행" 활성화 여부
    const [sleepLayerVisible, setSleepLayerVisible] = useState(false); // 졸음쉼터 레이어 가시성 상태

   
    const originalAlert = window.alert;
    window.alert = (message) => {
      if (message.includes("ERROR: No Embedding Target")) {
        return; // 특정 메시지는 표시하지 않음
      }
      originalAlert(message); // 다른 메시지는 그대로 실행
    };


    
  
   // 고속도로 선택 시 API 호출 (휴게소 및 졸음쉼터)
useEffect(() => {
  const fetchData = async () => {
    try {
      // 휴게소 데이터 호출
      const restAreaResponse = await axios.get('https://data.ex.co.kr/openapi/business/serviceAreaRoute', {
        params: {
          key: '4007645158',
          type: 'json',
          routeName: routeName,
          numOfRows: 100,
          pageNo: 1,
        },
      });
      const fetchedRestAreas = restAreaResponse.data.list?.map((area) => area.serviceAreaName) || [];
      setRestAreas(fetchedRestAreas);

      // 졸음쉼터 데이터 호출
      const sleepAreaResponse = await axios.get('http://api.data.go.kr/openapi/tn_pubr_public_drowsy_shelter_api', {
        params: {
          serviceKey: 'h59y864R6Hz+MLGtP047x8y7wu+naz4whRwgY+IVkqP9LYq0NZhQskdgWhbQ2Urx/5EqX74OCKPVXI0mghho1g==',
          type: 'json', // JSON 데이터 포맷 요청
          roadRouteNm: routeName, // 선택한 경로 값
          numOfRows: 100, // 한번에 가져올 데이터 수
          pageNo: 1, // 페이지 번호
        },
      });
      const fetchedSleepAreas = sleepAreaResponse.data.response.body.items || [];
      setSleepAreas(fetchedSleepAreas);
      console.log(fetchedSleepAreas);

      // 선택된 휴게소 초기화
      setSelectedRestArea('');
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  if (routeName) {
    fetchData();
  }
}, [routeName]);


console.log(restAreas);
console.log(selectedRestArea);
console.log("SelectInfo",selectedInfo);

  
    
    

    const basicInfo = {
      운영시간: `${selectedInfo?.open}~${selectedInfo?.close}`,
      전화번호: selectedInfo?.휴게소전화번호,
      대표음식: selectedInfo?.휴게소대표음식명,
    };
    
    const facilitiesInfo = {
      경정비: selectedInfo?.경정비가능여부 === "Y" ? "있음" : "없음",
      "전기차 충전소": selectedInfo?.전기차충전소유무 === "Y" ? "있음" : "없음",
      "LPG 충전소": selectedInfo?.LPG충전소유무 === "Y" ? "있음" : "없음",
      "주차면수": selectedInfo?.주차면수,
      "버스환승 가능": selectedInfo?.버스환승가능여부 === "Y" ? "가능" : "불가능",
    };
    
    const servicesInfo = {
      쉼터: selectedInfo?.쉼터유무 === "Y",
      약국: selectedInfo?.약국유무 === "Y",
      화장실: selectedInfo?.화장실유무 === "Y",
      수유실: selectedInfo?.수유실유무 === "Y",
      매점: selectedInfo?.매점유무 === "Y",
      음식점: selectedInfo?.음식점유무 === "Y",
    };


    const serviceIcons = {
      쉼터: resticon,
      약국: pharmacyicon,
      화장실: restroomicon,
      수유실: babyicon,
      매점: storeicon,
      음식점: foodicon,
    };


    //지도 관련 코드
    useEffect(() => {
      if (!routeName) return;

      // Tile Layer for the KoreaAOI layer
      const KoreaAOI = new TileLayer({
        source: new TileWMS({
          url: "https://k-aquas.dromii.com/geoserver/yeongju/wms",
          params: {
            LAYERS: 'yeongju:koreaAOI',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
    
      // Base Layer (OSM)
      const baseLayer = new TileLayer({
        source: new OSM(),
        visible: false,
      });

      const vworldLayer = new TileLayer({
        source: new XYZ({
          url: `http://api.vworld.kr/req/wmts/1.0.0/{apikey}/Satellite/{z}/{y}/{x}.jpeg`.replace(
            '{apikey}',
            '61C91BAF-6C05-3D8C-AC53-397EA4C8EEFB',
            
          ),
          crossOrigin: 'anonymous'
        }),
        visible: vworldVisible, // 초기 가시성
      });

      const GyeongbuExpress = new TileLayer({
        source: new TileWMS({
          url: "http://v3geoserver.dromii.com/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:GyeongbuExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
      const WestCoastExpress = new TileLayer({
        source: new TileWMS({
          url: "http://v3geoserver.dromii.com/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:West CoastExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
      const JungangExpress = new TileLayer({
        source: new TileWMS({
          url: "http://v3geoserver.dromii.com/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:JungangExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
     
    
       // 선택된 방향에 따라 데이터 필터링
      const filtered = gateway.filter(
        (item) =>
          item.도로노선명 === routeName &&
          ((isUp && item.도로노선방향 === "상행") || (isDown && item.도로노선방향 === "하행"))
      );

      setFilteredData(filtered);
    
      // Create features only for the filtered data
      const features = filtered.map((item) => {
        const { 경도, 위도, 휴게소명, 휴게소운영시작시각, 휴게소운영종료시각,휴게소전화번호, 주차면수 } = item;
        const feature = new Feature({
          geometry: new Point(fromLonLat([경도, 위도])),
          ...item,
          name: 휴게소명,
          open: 휴게소운영시작시각,
          close: 휴게소운영종료시각,
          num: 휴게소전화번호,
          car: 주차면수,
        });
        return feature;
      });
    
      // Cluster Source for the features
      const clusterSource = new Cluster({
        distance: 50,
        source: new VectorSource({
          features: features,
        }),
      });
    
      // Style for the clusters
      const clusterLayerStyle = (feature, hover = false) => {
        const size = feature.get("features").length;
        const isHovered = hover;
    
        return [
          new Style({
            image: new CircleStyle({
              radius: isHovered ? 15 : 12, // Emphasize effect radius change
              stroke: new Stroke({
                color: isHovered ? "#3c3d37" : "#938A7F", // Emphasize effect color change
                width: 2,
              }),
              fill: new Fill({
                color: isHovered ? "#3c3d37" : "#938A7F",
              }),
            }),
          }),
          new Style({
            image: new CircleStyle({
              radius: isHovered ? 7 : 5,
              fill: new Fill({
                color: "#ffffff",
              }),
            }),
          }),
          
        ];
      };
    
      // Cluster Layer for the map
      const clusterLayer = new VectorLayer({
        source: clusterSource,
        style: (feature) => clusterLayerStyle(feature),
       
      });

      // 졸음쉼터 데이터를 기반으로 `Feature` 생성
      const sleepfeatures = sleepAreas.map((area) => {
        const { longitude, latitude, shltrNm } = area;
        // console.log(area);
        return new Feature({
          geometry: new Point(fromLonLat([ longitude, latitude])),
          name: shltrNm,
        });
      });
      const sleepclusterSource = new Cluster({
        distance: 50, // 클러스터링 거리
        source: new VectorSource({
          features: sleepfeatures, // 올바른 속성명 사용
        }),
        
      });
      // 클러스터 스타일 정의
      const sleepclusterLayerStyle = (feature) => {
        const size = feature.get("features").length;
        return new Style({
          image: new Icon({
            src: sleepimg,
            scale: size > 0.5 ? 0.23 : 0.5, // 클러스터 크기에 따라 이미지 크기를 조정
          }),
          
         
        });
      };
      // 클러스터 레이어 생성
      const sleepclusterLayer = new VectorLayer({
        source: sleepclusterSource,
        style: (sleepfeature) => sleepclusterLayerStyle(sleepfeature),
        visible: sleepLayerVisible, // 🟢 상태 기반 가시성 설정
      });

      const initialView = new View({
        center: fromLonLat([127.9538, 36.3857]), // 초기 지도 중심 좌표
        zoom: 7.5,
        minZoom: 7,
      });
    
      // Map configuration
      const map = new Map({
        target: mapRef.current,
        layers: [KoreaAOI,vworldLayer,JungangExpress,WestCoastExpress,GyeongbuExpress, clusterLayer, sleepclusterLayer,],
        view: initialView,
      });

      setMap(map);
      setView(initialView); // View 저장
    
      // 팝업 컨테이너 요소 생성
      const popupContainer = document.createElement("div");
      popupContainer.className = "ol-popup";
      popupContainer.style.position = "absolute";
      popupContainer.style.background = "white";
      popupContainer.style.border = "1px solid #ccc";
      popupContainer.style.padding = "5px 10px";
      popupContainer.style.borderRadius = "5px";
      popupContainer.style.display = "none";
      document.body.appendChild(popupContainer);


      // OpenLayers Overlay 객체 생성
      const popupOverlay = new Overlay({
        element: popupContainer, // HTML 요소 연결
        positioning: "bottom-center", // 아이콘 위에 표시되도록 설정
        offset: [0, -15], // 약간 위로 이동
        autoPan: false, // 팝업이 보이도록 자동 이동
      });

      // 지도에 Overlay 추가
      map.addOverlay(popupOverlay);

    
      // Pointer move event for showing popup
      // 마우스를 올리면 팝업 표시
map.on("pointermove", (event) => {
  let popupVisible = false;
  let hoverFeature = null;

  map.forEachFeatureAtPixel(event.pixel, (feature) => {
    const clusteredFeatures = feature.get("features");
    if (clusteredFeatures.length > 0) {
      hoverFeature = feature;
      const firstFeature = clusteredFeatures[0];
      const properties = firstFeature.getProperties();

      // 팝업 내용 업데이트
      popupContainer.innerHTML = `
        <div class="popup-content">
          <h3 class="popup-title">${properties.name}휴게소</h3>
          <p>번호: ${properties.num}</p>
          <p>주차 면수: ${properties.car}</p>
        </div>
      `;

      // 팝업 좌표를 지도 기준으로 설정
      popupOverlay.setPosition(event.coordinate);
      popupContainer.style.display = "block"; // 팝업 표시

      popupVisible = true;
    }
});


  // 마우스가 나가면 팝업 숨김
  if (!popupVisible) {
    popupContainer.style.display = "none";
  }
});

    
      // Map click event to select a feature
      map.on("click", (event) => {
        map.forEachFeatureAtPixel(event.pixel, (feature) => {
          const clusteredFeatures = feature.get("features");
          if (clusteredFeatures.length === 1) {
            const properties = clusteredFeatures[0].getProperties();
            setSelectedInfo(properties);
          }
        });
      });
    
      // Mouse out event for resetting cluster styles
      map.on("pointerout", () => {
        // popup.style.display = "none";
        clusterSource.getFeatures().forEach((feature) => {
          feature.setStyle(clusterLayerStyle(feature, false));
        });
      });
    
      // Cleanup function to remove the map and popup
      return () => {
        map.setTarget(null);
        // document.body.removeChild(popup);
      };
    }, [routeName,isDown, isUp]); // Re-run effect whenever `routeName` changes


    // sleepAreas가 업데이트된 후 클러스터 레이어를 생성
useEffect(() => {
  if (!sleepAreas || sleepAreas.length === 0) return;

  // 졸음쉼터 데이터를 기반으로 `Feature` 생성
  const sleepfeatures = sleepAreas.map((area) => {
    const { longitude, latitude, shltrNm } = area;
    return new Feature({
      geometry: new Point(fromLonLat([longitude, latitude])),
      name: shltrNm,
    });
  });

  const sleepclusterSource = new Cluster({
    distance: 50, // 클러스터링 거리
    source: new VectorSource({
      features: sleepfeatures,
    }),
  });

  const sleepclusterLayerStyle = (feature) => {
    const size = feature.get("features").length;
    return new Style({
      image: new Icon({
        src: sleepimg,
        scale: size > 0.5 ? 0.23 : 0.5,
      }),
    });
  };

  const sleepclusterLayer = new VectorLayer({
    source: sleepclusterSource,
    style: (sleepfeature) => sleepclusterLayerStyle(sleepfeature),
    visible: sleepLayerVisible, // 🟢 상태 기반 가시성 설정
  });

  map.addLayer(sleepclusterLayer);

  return () => {
    map.removeLayer(sleepclusterLayer);
  };
}, [sleepAreas, sleepLayerVisible]); // sleepAreas가 변경될 때만 실행


    // useEffect to handle visibility based on routeName
    useEffect(() => {
      if (map) {
        // Find the layers for each route
        const gyeongbuLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:GyeongbuExpress';
        });

        const westCoastLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:West CoastExpress';
        });

        const jungangLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:JungangExpress';
        });

        // Update visibility based on routeName
        if (gyeongbuLayer) {
          gyeongbuLayer.setVisible(routeName === '경부선');
        }
        if (westCoastLayer) {
          westCoastLayer.setVisible(routeName === '서해안선');
        }
        if (jungangLayer) {
          jungangLayer.setVisible(routeName === '중앙선');
        }
      }
    }, [routeName, map]);

    useEffect(() => {
      if (map) {
        const vworldLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof XYZ;
        });
        if (vworldLayer) {
          vworldLayer.setVisible(vworldVisible);
        }
      }
    }, [vworldVisible, map]);

    // 사용자 위치로 이동하는 함수
    const moveToUserLocation = () => {
      if (!navigator.geolocation) {
        alert("Geolocation이 지원되지 않는 브라우저입니다.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const userCoordinates = fromLonLat([longitude, latitude]); // 경도, 위도를 OpenLayers 좌표로 변환

          view.animate({
            center: userCoordinates, // 사용자 위치로 이동
            zoom: 15, // 확대 레벨
            duration: 1000, // 애니메이션 지속 시간 (밀리초)
          });
        },
        (error) => {
          console.error("사용자 위치를 가져오는 데 실패했습니다:", error);
          alert("사용자 위치를 가져올 수 없습니다.");
        }
      );
    };
    
    const handleClick = () => {
      setIsExpanded(!isExpanded); // 상태를 반전시킴
      setSymbol(prev => (prev === '❯' ? '❮' : '❯')); // 기호 변경
    };

    const handleZoomIn = () => {
      if (view) {
        view.setZoom(view.getZoom() + 1);
      }
    };

    const handleZoomOut = () => {
      if (view) {
        view.setZoom(view.getZoom() - 1);
      }
    };

    const togglePopup = () => {
      setIsPopupVisible((prev) => !prev);
    };

    const toggleVworldLayer = () => {
      setVworldVisible((prev) => !prev); // 상태 토글
    };

   
    
    return(
      <>
       <Header></Header>
       <Container>
          <Tab onClick={handleClick} left={isExpanded ? '0px' : '50%'}>
          {symbol}
          </Tab>
            <InfoContainer visible={isExpanded ? 'none' : 'flex'} >
             
              <KrpanoExample selectedInfo={selectedInfo}/>
              
           
           <IntroductionGateWayBox>
            
            {selectedInfo ? (
              <>
                <InfoTitle >
                  <InfoImg src={oneload}/>
                  {selectedInfo?.휴게소명} 휴게소
                  </InfoTitle>
                <IntroductionGateWay>
                 
               
                <div className="info-boxd">
                <h3>기본 정보</h3>
                    <ul>
                      {Object.entries(basicInfo).map(([key, value]) => (
                        <li key={key}>
                          <strong>{key}</strong> <span>{value || "정보 없음"}</span>
                        </li>
                      ))}
                    </ul>
                 
                  </div>
                
                  <div className="info-box">
                  <h3>차량 정보</h3>
                  <ul>
                      {Object.entries(facilitiesInfo).map(([key, value]) => (
                        <li key={key}>
                          <strong>{key}</strong>: {value}
                        </li>
                      ))}
                    </ul>
                  
                  </div>
                </IntroductionGateWay>
              
                {/* 편의 시설 섹션 */}
               
                <IntroductionGateWay>
  <div className="info-boxs">
    <h3> 편의 시설 및 서비스</h3>
    <ul style={{ display: "flex", flexWrap: "wrap", justifyContent:'space-around' }}>
      {Object.entries(servicesInfo).map(([key, available]) => (
        <div style={{display:'flex', alignItems:'center',fontSize: '14px',
        fontWeight: 'bold', flexDirection:'column',justifyContent:'center',
        color: '#555',}}>
        
       
        <Box
          key={key}
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "5px",
            backgroundColor: available ? "#ffffff" : "#636363",
            marginBottom:'5px'
            
            
          }}
        >
          <img
            src={serviceIcons[key]}
            alt={key}
            style={{
              width: 40,
              height: 40,
              opacity:1,
              borderRadius: "5px"
            }}
          />
         
        </Box>
        {key}
        </div>
      ))}
    </ul>
  </div>
</IntroductionGateWay>

              </>
            ) : (
              <p>휴게소를 선택해주세요.</p>
            )}
            </IntroductionGateWayBox>


            </InfoContainer>
           
            <ControlBox>
   
           
            <LayerBox onClick={togglePopup}>
              <Layerimg src={layericon}/>
            </LayerBox>
             
            <Userlocation onClick={moveToUserLocation}>
            <Layerimg src={pointicon}/>
            </Userlocation>
            <ZoomBox>
              <ZoomBtn style={{borderBottom:'1px solid #C0C0C0'}} onClick={handleZoomIn}>+</ZoomBtn>
              <ZoomBtn style={{borderTop:'1px solid #C0C0C0'}} onClick={handleZoomOut}>−</ZoomBtn>
            </ZoomBox>
            </ControlBox>
            {isPopupVisible && (
                <LayerPopup>
                  <LayerPopupHeader>지도설정</LayerPopupHeader>
                  <LayerPopupBody>
                    <LayerControl>cctv</LayerControl>
                    <LayerControl onClick={toggleVworldLayer}
                      style={{
                        color: vworldVisible ? '#D5445C' : 'black',
                        cursor: 'pointer',
                    }}>위성</LayerControl>
                  </LayerPopupBody>
                </LayerPopup>
              )}
            
            <MapContainer width={isExpanded ? '100%' : '50%'}>
              <SleepLayerControl>
              <FormControlLabel
             
              control={
                <Switch
                  checked={sleepLayerVisible}
                  onChange={() => setSleepLayerVisible((prev) => !prev)}
                  color="primary"
                />
              }
              
            />
                졸음쉼터
              </SleepLayerControl>
              <DownLineLayerControl>
                {/* 하행선 스위치 */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isDown}
                        onChange={() => setIsDown((prev) => !prev)}
                        color="primary"
                      />
                    }                                 
                  />
                  하행선
              </DownLineLayerControl>
              <UpLineLayerControl>
                  <FormControlLabel
                  control={
                  <Switch
                  checked={isUp}
                  onChange={() => setIsUp((prev) => !prev)}
                  color="primary"
                  />
                  }
                  />
                   상행선
              </UpLineLayerControl>
          
              <Legend src={legendimg}/>

                <MapHeader>
                    <SelectHighway>
                    <SelectWrapper>
      <SelectBox
        value={routeName}
        onChange={(e) => setRouteName(e.target.value)}
      >
        {highwayOptions.map((highway) => (
          <option key={highway} value={highway}>
            {highway}
          </option>
        ))}
      </SelectBox>
      <ArrowIcon>▼</ArrowIcon>
    </SelectWrapper>
                    </SelectHighway>
                    <SelectRestArea>
                    <SelectWrapper>
      <SelectBox
    value={selectedRestArea}
    onChange={(e) => {
      setSelectedRestArea(e.target.value);   
    }}
  >
    {/* <option value="" disabled>
      휴게소를 선택하세요
    </option> */}
    {restAreas?.length > 0 ? (
      restAreas.map((restArea) => (
        <option key={restArea} value={restArea}>
          {restArea}
        </option>
      ))
    ) : (
      <option value="" disabled>
        해당 고속도로에 휴게소 없음
      </option>
    )}
   </SelectBox>
      <ArrowIcon>▼</ArrowIcon>
    </SelectWrapper>
                    </SelectRestArea>
                </MapHeader>
                <div 
                ref={mapRef} // 지도를 렌더링할 div 요소
                style={{
                  width: "100%",
                  height: "95%", // 지도 크기
                  backgroundColor:"#78C0F5"
                }}
                ></div>

            </MapContainer>
        </Container>
        <Footer></Footer>
      </>
       
    )
};

export default TrafficInformationPage;

const Container = styled.div`
width:100%;
display:flex;
height:100vh;
.ol-attribution ul{
  display:flex;
 
}
.ol-zoom {
  margin-top:20px;
  top: 0px;
  left: 7px;
  display:none;
}
.ol-popup {
  position: absolute;
  display:flex;
  justify-content: center;
  align-items: center;
  width:180px;
  height:max-contents;
  bottom: 12px;
  left: -50px;
  background: white;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  display: none; /* 기본적으로 숨김 */
}
.ol-popup {
  pointer-events: none; /* 팝업이 마우스 이벤트를 차단하지 않도록 설정 */
}
.popup-container {
  position: absolute;
  background-color: white;
  border: 2px solid #333;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  font-family: Arial, sans-serif;
  z-index: 1000;
  display: none; /* 처음엔 숨김 */
  transition: opacity 0.3s ease-in-out;
}

.popup-content {
 
}

.popup-title {
  font-size: 1.2em;
  color: #333;
 
}

.popup-container p {
  font-size: 1em;
  color: #555;
}

.popup-container strong {
  font-weight: bold;
  color: #444;
}

.popup-container::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #333;
}

`;

const Tab = styled.div`
position: absolute;
width:30px;
height:60px;
background-color:white;
top:60vh;
left:${(props) => props.left};
z-index:1000;
border-radius: 0px 4px 4px 0px;
border-left:1.5px solid #BFB4A5;
display:flex;
justify-content: center;
align-items: center;
color:#dbdbdb;
&:hover {
color: #BFB4A5; /* 원하는 색상으로 변경 */
`;

const InfoContainer = styled.div`
height:100%;
width:50%;
flex-direction: column;
display:${(props) => props.visible};
border-right:3px solid #BFB4A5;

`;


const IntroductionGateWayBox = styled.div`
  padding: 10px;
  height:60vh;
  overflow:hidden;
 
`;

const IntroductionGateWay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  padding: 5px;
  font-family: 'Arial', sans-serif;
  background-color: #fff;


  h2 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-bottom:1px solid black;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 10px;
  }

  .name-box{
    width: 40%;
   display:flex;
   align-items:center;
   justify-content:center;
    border-radius: 5px;
    padding: 15px;

  }
  .info-boxd {
    width: 40%;
    border: 1px solid #e0e0e0;
    padding: 5px 15px;
    border-radius:8px;
    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #555;
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(1, 1fr); /* 3열 */
      gap: 10px; /* 각 아이템 사이 여백 */
      
      li {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 8px;
        font-size: 14px;

        strong {
          color: #555;
          font-weight: bold;
          margin-left:20px;
        }

        span {
          color: #333;
          margin-left:30px;
        }
      }
    }
  }
  .info-boxs {
    width: 100%;
    border: 1px solid #e0e0e0;
    padding: 5px 15px;
    border-radius:8px;
    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #555;
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* 3열 */
      gap: 10px; /* 각 아이템 사이 여백 */
      
      li {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 8px;
        font-size: 14px;

        strong {
          color: #555;
          font-weight: bold;
          margin-left:20px;
        }

        span {
          color: #333;
          margin-left:30px;
        }
      }
    }
  }
  

  .info-box {
    width: 45%;
    border: 1px solid #e0e0e0;
    padding: 5px 15px;
    border-radius:8px;

    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #555;
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr); /* 3열 */
      gap: 10px; /* 각 아이템 사이 여백 */

      li {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 8px;
        font-size: 14px;

        strong {
          color: #555;
          font-weight: bold;
          margin-left:20px;
        }

        span {
          color: #333;
          margin-left:30px;
        }
      }
    }
  }
`;
const IntroductionGateWayTab = styled.div`
width:100%;
height:50px;
background-color:#F3F3F3;
display:flex;
align-items:center;
font-weight:800;

`;

const MapContainer = styled.div`
height:100%;
width:${(props) => props.width};
display:flex;
flex-direction: column;
`;
const MapHeader = styled.div`
width:100%;
height:50px;
display:flex;
border-bottom: 1px solid gray;
background-color:white;
`;

const SelectHighway = styled.div`
height:100%;
width:50%;
display:flex;
align-items:center;
padding:0px 20px;
font-size:18px;
font-weight:600;
border-right: 0.5px solid gray;
`;
const SelectRestArea = styled.div`
height:100%;
width:50%;
display:flex;
align-items:center;
padding:0px 20px;
font-size:18px;
font-weight:600;
border-left: 0.5px solid gray;
`;


const ControlBox = styled.div`
z-index:1009;
position: absolute;
right:20px;
top:85vh;
height:180px;
display:flex;
flex-direction:column;
align-items:center;
justify-content: space-around;
`;
const LayerBox = styled.div`
z-index:1000;
width:40px;
height:40px;
border-radius:10px;
display:flex;
align-items:center;
justify-content: center;
background-color:black;
&:hover{
  background-color:#D5445C
}
`;

const Layerimg = styled.img`
width:100%;
border-radius:10px;
`

const Userlocation = styled.div`
z-index:1000;
width:40px;
height:40px;
border-radius:10px;
background-color:black;
display:flex;
align-items:center;
justify-content: center;
&:hover{
  background-color:#D5445C
}
`;

const ZoomBox = styled.div`

z-index:1000;

width:40px;
height:80px;
border-radius:10px;
background-color:white;
`;

const ZoomBtn = styled.div`
width:40px;
height:40px;
display:flex;
align-items:center;
justify-content: center;
font-size:18px;
&:hover{
  color:#D5445C
}
`

const LayerPopup = styled.div`
position: absolute;
z-index:1009;
right:70px;
top:80vh;
width:160px;
height:130px;
border-radius:10px;
background-color:#ffffff;
display:flex;
flex-direction: column;
justify-content: center;
padding:10px 20px;


`

const LayerPopupHeader = styled.div`
width: 100%;
height:25px;
display:flex;
align-items:center;
border-bottom: 1px solid #c0c0c0;
font-size:12px;

`

const LayerPopupBody = styled.div`
`;

const LayerControl = styled.div`
width:100%;
height:30px;
border: 1px solid #c0c0c0;
border-radius:10px;
margin-top:10px;
display:flex;
align-items:center;
justify-content: center;
&:hover{
  color:#D5445C;
  border: 1px solid #D5445C;
}
`;

const Legend = styled.img`
position: absolute;
z-index:1000;
max-width:120px;
min-width:100px;
width:12vw;
top:140px;
margin-left:10px;
`;


const SelectWrapper = styled.div`
  width: 100%;
  margin: 20px 0;
  position: relative;
`;

const SelectBox = styled.select`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  color: #333;
  
  
  border-radius: 5px;
  appearance: none; /* 기본 드롭다운 화살표 제거 */
  cursor: pointer;

  &:focus {
    outline: none;
    // border-color: #007bff;
  }

  // &:hover {
  //   background-color: #e8e8e8;
  // }
`;

const ArrowIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #777;
  font-size: 16px;
`;
const InfoTitle = styled.div`

display:flex;
align-items:center;
justify-content: center;
font-weight:600;
font-size:24px;
gap:20px;
`;
const InfoImg =styled.img`
width:8%;
`;


const SleepLayerControl = styled.div`
display:flex;
align-items:center;
justify-content: space-around;
position: absolute;
z-index:1000;
max-width:140px;
min-width:100px;
width:12vw;
top:140px;
right:10px;
font-size:14px;
font-weight:700;
background-color:white;
border-radius:10px;
`

const DownLineLayerControl = styled.div`
display:flex;
align-items:center;
justify-content: space-around;
position: absolute;
z-index:1000;
max-width:140px;
min-width:100px;
width:12vw;
top:180px;
right:10px;
font-size:14px;
font-weight:700;
background-color:white;
border-radius:10px;
`

const UpLineLayerControl = styled.div`
display:flex;
align-items:center;
justify-content: space-around;
position: absolute;
z-index:1000;
max-width:140px;
min-width:100px;
width:12vw;
top:220px;
right:10px;
font-size:14px;
font-weight:700;
background-color:white;
border-radius:10px;
`